import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { OrdersPopupComponent } from '../mf/orders-popup/orders-popup.component';

interface TableColumn {
  name: string;
  width: string;
}

interface Order {
  orderName: string;
  selectedFrequency?: string;
  selectedUrgency?: string;
  orderTime?: string;
  reportTime?: string;
  orderDay?: string;
  orderReturnTime?: string;
  responseShown?: boolean;
  orderType?: number;
  [key: string]: any;
}

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit, OnChanges {

  @Input() orderList: any;
  @Input() currentTime: string = '';
  @Input() currentCaseDay: number = 1;        // New input for current simulation day
  @Input() currentCaseTime: string = '00:00'; // New input for current simulation time
  @Input() savedOrders: Order[] = [];
  @Input() vitalSignsHistory: any[] = [];
  @Input() progressNotes: any[] = [];
  @Input() selectedOrderIds: number[] = []; // New input for selected order IDs
  @Input() cancelledOrders: any[] = []; // New input for cancelled orders
  @Output() ordersUpdated = new EventEmitter<any[]>();
  @Output() showVitalSigns = new EventEmitter<any>();
  @Output() showProgressNote = new EventEmitter<{response: string, title: string}>();
  @Output() showOrderResult = new EventEmitter<{response: string, title: string}>();
  @Output() orderCancelled = new EventEmitter<Order>(); // New output for cancelled orders



  selectedOrderTocancel: any;
  tabs = [
    'Order Sheet',
    'Progress Notes',
    'Vital Signs',
    'Lab Reports',
    'Imaging',
    'Other Tests',
    'Treatment Records'
  ];


     // frequency list 
     frequencyList = [
      {
          "id": 0,
          "type": "N/A"
      },
      {
          "id": 1,
          "type": "Continuous"
      },
      {
          "id": 2,
          "type": "Every X"
      },
      {
          "id": 3,
          "type": "One Time/Bolus"
      }
  ]
    // ungencry array
    urgCodes = [
      {
          "id": 0,
          "type": "N/A",
          "reportTime": "0"
      },
      {
          "id": 1,
          "type": "Routine",
          "reportTime": "8"
      },
      {
          "id": 2,
          "type": "Stat",
          "reportTime": "4"
      }
  ]
  
  //routes array  
  routeCodes = [
    {
        "id": 0,
        "type": "N/A",
        "abbr": "N/A"
    },
    {
        "id": 1,
        "type": "Epidural",
        "abbr": "ED"
    },
    {
        "id": 2,
        "type": "IntraArticular",
        "abbr": "IA"
    },
    {
        "id": 3,
        "type": "IntraMuscular",
        "abbr": "IM"
    },
    {
        "id": 4,
        "type": "Intravenous",
        "abbr": "IV"
    },
    {
        "id": 5,
        "type": "Inhalation",
        "abbr": "IN"
    },
    {
        "id": 6,
        "type": "opthalmic",
        "abbr": "OP"
    },
    {
        "id": 7,
        "type": "Oral",
        "abbr": "PO"
    },
    {
        "id": 8,
        "type": "Otic",
        "abbr": "OT"
    },
    {
        "id": 9,
        "type": "Rectal",
        "abbr": "RE"
    },
    {
        "id": 10,
        "type": "Subcutaneous",
        "abbr": "SC"
    },
    {
        "id": 11,
        "type": "Sublingual",
        "abbr": "SL"
    },
    {
        "id": 12,
        "type": "Topical",
        "abbr": "TP"
    },
    {
        "id": 13,
        "type": "Vaginal",
        "abbr": "VA"
    }
  ]

  activeTab = 'Order Sheet';
  showOrderButton = false;
  showPopup = false;

  showCancelOrderConfirmation = false;
  
  // New properties for prerequisite cancellation
  showPrerequisiteCancelConfirmation = false;
  prerequisiteCancelMessage = '';
  parentOrdersToCancel: Order[] = [];

  // Categorized order arrays
  private activeOrders: Order[] = [];
  private labReports: Order[] = [];
  private otherTests: Order[] = [];
  private imagingReports: Order[] = [];
  private progressNotesOrders: Order[] = [];

  // Get the appropriate data based on active tab
  get selectedOrders(): any[] {

    switch (this.activeTab) {
      case 'Order Sheet':
        return this.activeOrders;
      case 'Progress Notes':
        return [...this.progressNotes, ...this.progressNotesOrders];
      case 'Vital Signs':
        return this.vitalSignsHistory;
      case 'Lab Reports':
        return this.labReports;
      case 'Imaging':
        return this.imagingReports;
      case 'Other Tests':
        return this.otherTests;
      default:
        return this._selectedOrders;
    }
  }

  set selectedOrders(orders: any[]) {
    this._selectedOrders = orders;
    this.categorizeOrders();
  }

  private _selectedOrders: Order[] = [];

  constructor() { }

  ngOnInit(): void {
   
    this.updateOrderButtonVisibility();
    
    // Initialize _selectedOrders with savedOrders if they exist
    if (this.savedOrders && this.savedOrders.length > 0) {
      this._selectedOrders = [...this.savedOrders];
      this.categorizeOrders();
    }
  }

  ngOnChanges(): void {
    
    // Recategorize orders when savedOrders input changes
    if (this.savedOrders && this.savedOrders.length > 0) {
      this._selectedOrders = [...this.savedOrders];
      this.categorizeOrders();
    }
  }

  private categorizeOrders(): void {
    // Reset all categorized arrays
    this.activeOrders = [];
    this.labReports = [];
    this.otherTests = [];
    this.imagingReports = [];
    this.progressNotesOrders = [];

    // Categorize orders based on responseShown status and orderType
    this._selectedOrders.forEach(order => {
      if (!order.responseShown) {
        // Orders that haven't shown response yet go to Order Sheet
        this.activeOrders.push(order);
      } else {
        // Orders that have shown response get categorized by orderType
        switch (order.orderType) {
          case 6:
            this.labReports.push(order);
            break;
          case 9:
            this.otherTests.push(order);
            break;
          case 4:
            this.imagingReports.push(order);
            break;
          default:
            // All other orderTypes go to Progress Notes
            this.progressNotesOrders.push(order);
            break;
        }
      }
    });

    // console.log('Orders categorized:', {
    //   active: this.activeOrders.length,
    //   labReports: this.labReports.length,
    //   otherTests: this.otherTests.length,
    //   imaging: this.imagingReports.length,
    //   progressNotes: this.progressNotesOrders.length
    // });
  }

  onTabChange(tab: string): void {
    this.activeTab = tab;
    this.updateOrderButtonVisibility();
  }

  private updateOrderButtonVisibility(): void {
    this.showOrderButton = this.activeTab === 'Order Sheet';
  }

  onOrderClick(): void {
    this.showPopup = true;
  }

  onPopupClose(): void {
    this.showPopup = false;
  }

  onOrdersConfirm(data: {order: Order, isPrerequisite: boolean}): void {
    const { order, isPrerequisite } = data;
    
    // Add timing information to the order
    const orderWithTime = {
      ...order,
      orderTime: this.currentTime,
      reportTime: '-',
      responseShown: false // New orders start as not shown
    };
    
    // Add to selected orders
    this._selectedOrders.push(orderWithTime);
    this.categorizeOrders(); // Recategorize after adding new order
    
    // Emit the updated orders
    this.ordersUpdated.emit(this._selectedOrders);
    
    // Only close popup if this is NOT a prerequisite (i.e., it's the main order)
    if (!isPrerequisite) {
      this.showPopup = false;
    }
  }

  // Helper method to get cell value based on column name
  getCellValue(order: any, columnName: string): string {
    switch (columnName) {
      case 'Order':
        // For progress notes and vital signs, show the type as the order
        return order.orderName || order.type || '-';
      case 'Router/Urgency':
        if (order.routeUrgencyId == '1') {
          // return the list of all the values from the route array 
          // return the route value from   the route array based on selectedRouteOption in order object
          const route = this.routeCodes.find(r => r.id === order.selectedRouteOption);
          return route ? route.type : '-';
        } else if (order.routeUrgencyId == '2') {
          // return the list of all the values from the urgency array 
            // return the urgency value from the urgency array based on selectedUrgencyOption in order object
            const urgency = this.urgCodes.find(u => u.id === order.selectedUrgencyOption);
            return urgency ? urgency.type : '-';  
        } else {
          return '-'
        }
        // return order.selectedUrgency || '-';
      case 'Frequency':
        
      if (order.selectedFrequency)
      {
        return `Every ${order.selectedFrequency} hours`
      }
      else{  // return the the frequency value from the frequency array based on selectedFrequencyOption in order object
        const frequency = this.frequencyList.find(f => f.id === order.selectedFrequencyOption);
        return frequency ? frequency.type : '-';

      }
      
        
        // return order.selectedFrequency ? `Every ${order.selectedFrequency} hours` : '-';
      case 'Order Time':
        return order.orderTime || order.time || '-';
      case 'Report Time':
        if (order.orderDay && order.orderReturnTime) {
          const hours = order.orderReturnTime.substring(0, 2);
          const minutes = order.orderReturnTime.substring(2);
          return `Day ${order.orderDay} @ ${hours}:${minutes}`;
        }
        return order.reportTime || order.time || '-';
      case 'Time Ordered':
        return order.orderTime || '-';
      case 'Time Reported':
        return order.reportTime || order.time || '-';
      default:
        return '-';
    }
  }

  // Table columns based on active tab
  get tableColumns(): TableColumn[] {
    switch (this.activeTab) {
      case 'Order Sheet':
        return [
          { name: 'Order', width: '45%' },
          { name: 'Router/Urgency', width: '13.75%' },
          { name: 'Frequency', width: '13.75%' },
          { name: 'Order Time', width: '13.75%' },
          { name: 'Report Time', width: '13.75%' }
        ];
      case 'Progress Notes':
      case 'Vital Signs':
        return [
          { name: 'Order', width: '65%' },
          { name: 'Order Time', width: '17.5%' },
          { name: 'Report Time', width: '17.5%' }
        ];
      case 'Treatment Records':
        return [
          { name: 'Order', width: '65%' },
          { name: 'Time Ordered', width: '35%' }
        ];
      default:
        return [
          { name: 'Order', width: '65%' },
          { name: 'Time Ordered', width: '17.5%' },
          { name: 'Report Time', width: '17.5%' }
        ];
    }
  }

  showResponse(order: any): void {
    
    // Handle different response types based on active tab and order properties

    if (this.activeTab === 'Order Sheet') {
      // Check if this order is a prerequisite before showing cancellation popup
      this.selectedOrderTocancel = order;
      
      if (this.isPrerequisiteOrder(order)) {
        // Show prerequisite cancellation popup
        this.showPrerequisiteCancellationPopup(order);
      } else {
        // Show normal cancellation popup
        this.showCancelOrderConfirmation = true;
      }
    }
    else if (this.activeTab === 'Vital Signs') {
      // Show vital signs popup when vital signs tab is active
      this.showVitalSignsPopup(order);
    } else if (this.activeTab === 'Progress Notes') {
      // Handle progress notes responses
      if (order.type === 'Introduction' || order.type === 'History of Present Illness' || order.type === 'Patient Condition Update') {
        // Response is in the 'description' variable
        this.showProgressNoteResponse(order.description, order.type);
      } 
      
        else {
        // For other progress note types, 
        console.log(order)
        this.showProgressNoteResponse(order.response || order.response, order.orderName);
      }
    } else {
      // For all other tabs (Lab Reports, Imaging, Other Tests, etc.)
      
      if (order.response) {
        this.showOrderResponse(order.response, order.orderName );
      }
    }
  }

  private showVitalSignsPopup(order: any): void {
    // Emit event to parent component to show vital signs popup
    
    this.showVitalSigns.emit(order);
  }

  private showProgressNoteResponse(response: string, title: string): void {
    // Emit event to parent component to show progress note response
    this.showProgressNote.emit({ response, title });
  }

  private showOrderResponse(response: string, title: string): void {
    // Emit event to parent component to show order response
    this.showOrderResult.emit({ response, title });
  }

  // New method to check if an order is a prerequisite for any other order
  private isPrerequisiteOrder(orderToCheck: Order): boolean {
    const isPrereq = this._selectedOrders.some(order => {
      const prerequisiteIds = this.parsePrerequisites(order);
      return prerequisiteIds.includes(orderToCheck.id);
    });
    
    // Debug logging
    if (isPrereq) {
      console.log(`Order "${orderToCheck.orderName}" (ID: ${orderToCheck.id}) is a prerequisite for other orders`);
      this.debugPrerequisiteRelationships();
    }
    
    return isPrereq;
  }

  // Debug method to visualize prerequisite relationships
  private debugPrerequisiteRelationships(): void {
    console.log('=== Current Prerequisite Relationships ===');
    this._selectedOrders.forEach(order => {
      const prerequisiteIds = this.parsePrerequisites(order);
      if (prerequisiteIds.length > 0) {
        const prerequisiteNames = prerequisiteIds
          .map(id => {
            const prereqOrder = this._selectedOrders.find(o => o.id === id);
            return prereqOrder ? prereqOrder.orderName : `Unknown (ID: ${id})`;
          })
          .join(', ');
        console.log(`"${order.orderName}" (ID: ${order.id}) requires: ${prerequisiteNames}`);
      }
    });
    console.log('==========================================');
  }

  // Test method to verify recursive dependency logic (can be called from browser console)
  public testRecursiveDependencies(): void {
    console.log('=== Testing Recursive Dependencies ===');
    this._selectedOrders.forEach(order => {
      const dependents = this.findAllDependentOrders(order.id);
      if (dependents.length > 0) {
        console.log(`If "${order.orderName}" (ID: ${order.id}) is cancelled, these orders will also be cancelled:`);
        dependents.forEach(dependent => {
          console.log(`  - "${dependent.orderName}" (ID: ${dependent.id})`);
        });
      }
    });
    console.log('=====================================');
  }

  // New method to parse prerequisite orders from string (similar to orders-popup component)
  private parsePrerequisites(order: Order): number[] {
    if (!order.prerequisiteOrder || order.prerequisiteOrder.trim() === '') {
      return [];
    }
    
    try {
      // First try to parse as JSON array (e.g., "[198351,729662,430830]")
      if (order.prerequisiteOrder.startsWith('[') && order.prerequisiteOrder.endsWith(']')) {
        const parsedArray = JSON.parse(order.prerequisiteOrder);
        if (Array.isArray(parsedArray)) {
          return parsedArray.map(id => parseInt(id)).filter(id => !isNaN(id));
        }
      }
      
      // Fallback: Handle comma-separated IDs (e.g., "198351,729662,430830")
      return order.prerequisiteOrder
        .split(',')
        .map(id => parseInt(id.trim()))
        .filter(id => !isNaN(id));
    } catch (e) {
      console.error('Error parsing prerequisite orders:', e);
      return [];
    }
  }

  // New method to find all parent orders that depend on the given prerequisite
  private findParentOrders(prerequisiteOrderId: number): Order[] {
    return this._selectedOrders.filter(order => {
      const prerequisiteIds = this.parsePrerequisites(order);
      return prerequisiteIds.includes(prerequisiteOrderId);
    });
  }

  // New method to recursively find all dependent orders (including nested dependencies)
  private findAllDependentOrders(prerequisiteOrderId: number): Order[] {
    const dependentOrders: Order[] = [];
    const visited = new Set<number>(); // Prevent infinite loops
    
    const findDependentsRecursively = (orderId: number) => {
      if (visited.has(orderId)) {
        return; // Prevent infinite loops
      }
      visited.add(orderId);
      
      // Find direct dependents of this order
      const directDependents = this._selectedOrders.filter(order => {
        const prerequisiteIds = this.parsePrerequisites(order);
        return prerequisiteIds.includes(orderId);
      });
      
      // Add direct dependents and recursively find their dependents
      directDependents.forEach(dependent => {
        if (!dependentOrders.some(existing => existing.id === dependent.id)) {
          dependentOrders.push(dependent);
          // Recursively find orders that depend on this dependent order
          findDependentsRecursively(dependent.id);
        }
      });
    };
    
    findDependentsRecursively(prerequisiteOrderId);
    return dependentOrders;
  }

  // New method to get parent order names for display
  private getParentOrderNames(prerequisiteOrder: Order): string[] {
    const parentOrders = this.findAllDependentOrders(prerequisiteOrder.id);
    return parentOrders.map(order => order.orderName);
  }

  // New method to show prerequisite cancellation popup
  private showPrerequisiteCancellationPopup(prerequisiteOrder: Order): void {
    const parentOrderNames = this.getParentOrderNames(prerequisiteOrder);
    this.parentOrdersToCancel = this.findAllDependentOrders(prerequisiteOrder.id);
    
    // Debug logging
    console.log(`Canceling prerequisite order: ${prerequisiteOrder.orderName} (ID: ${prerequisiteOrder.id})`);
    console.log('All dependent orders found:', this.parentOrdersToCancel.map(order => `${order.orderName} (ID: ${order.id})`));
    
    if (parentOrderNames.length > 0) {
      const parentNamesText = parentOrderNames.length === 1 
        ? parentOrderNames[0]
        : parentOrderNames.slice(0, -1).join(', ') + ' and ' + parentOrderNames[parentOrderNames.length - 1];
      
      this.prerequisiteCancelMessage = `The order "${prerequisiteOrder.orderName}" is a prerequisite for ${parentNamesText}. Canceling this may cause other orders to be cancelled too. Cancel anyway?`;
      this.showPrerequisiteCancelConfirmation = true;
    }
  }

  cancelOrder(): void {
    if (this.selectedOrderTocancel) {
      // Emit the cancelled order so parent can handle restoration
      this.orderCancelled.emit(this.selectedOrderTocancel);
      
      // Remove the order from _selectedOrders (not just activeOrders)
      this._selectedOrders = this._selectedOrders.filter(order => order.id !== this.selectedOrderTocancel.id);
      
      // Recategorize orders after removal
      this.categorizeOrders();
      
      // Emit updated orders to parent
      this.ordersUpdated.emit(this._selectedOrders);
      
      this.showCancelOrderConfirmation = false;
      this.selectedOrderTocancel = null;
    }
  }

  // New method to handle prerequisite order cancellation with cascading effects
  cancelPrerequisiteOrder(): void {
    if (this.selectedOrderTocancel) {
      const ordersToRemove = [this.selectedOrderTocancel, ...this.parentOrdersToCancel];
      
      // Debug logging
      console.log('Orders to be removed:', ordersToRemove.map(order => `${order.orderName} (ID: ${order.id})`));
      
      // Emit all cancelled orders so parent can handle restoration
      ordersToRemove.forEach(order => {
        this.orderCancelled.emit(order);
      });
      
      // Remove all affected orders from _selectedOrders
      const orderIdsToRemove = ordersToRemove.map(order => order.id);
      this._selectedOrders = this._selectedOrders.filter(order => 
        !orderIdsToRemove.includes(order.id)
      );
      
      console.log('Remaining orders after cancellation:', this._selectedOrders.map(order => `${order.orderName} (ID: ${order.id})`));
      
      // Recategorize orders after removal
      this.categorizeOrders();
      
      // Emit updated orders to parent
      this.ordersUpdated.emit(this._selectedOrders);
      
      // Clean up
      this.showPrerequisiteCancelConfirmation = false;
      this.selectedOrderTocancel = null;
      this.parentOrdersToCancel = [];
      this.prerequisiteCancelMessage = '';
    }
  }

  closeCancelOrderConfirmation(): void {
    this.showCancelOrderConfirmation = false;
  }

  // New method to close prerequisite cancellation confirmation
  closePrerequisiteCancelConfirmation(): void {
    this.showPrerequisiteCancelConfirmation = false;
    this.selectedOrderTocancel = null;
    this.parentOrdersToCancel = [];
    this.prerequisiteCancelMessage = '';
  }
}
